// This is Current 35.500 release //
import React, { useEffect, useState, ReactElement } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Flexbox, LoadingProgress, ScrollBar } from '@framework-controls/core';
import { IView } from 'Framework';
import { IconSchAppt, IconYourAcct, IconCheckRepair } from 'src/content/icons';
import { strings } from 'src/localization';
import * as css from './LandingPage.module.scss';
import { ComponentMapIds } from 'src/components/map';
import LandingButton from './LandingButton/LandingButton';
import { Recom, MaintenanceContract, Recall, SpecData, DecodeRec, NewVehicle, UpdateApptVehInp, VehicleRec, VehicleRecs, UpdateApptOpsInp, VehData, Customer, UpdateApptCustInp, UpdateApptDateInp, ViewApptList, DeteremineDeptInp, RepairOrder, ServiceDocsData, ascPageviewInput, ascCtaInteractionInput, ascRetailProcessInput } from 'src/models';
import { ViewMode } from 'src/enums';
import Logo from '../Logo/Logo';
import { getBackgroundPath } from '../../helpers/OEMHelper/OEMHelper';
import { ascCtaInteraction, ascPageview, ascRetailProcess } from 'src/helpers/EventHelper/EventHelper';
// Keep these two lines comement out so they can be used when needed to get xlate files
// import { UILocalizationENUS } from 'src/localization/en-US';
// import { Translation } from '@reynolds/translation';
import { useHistory } from 'react-router';
// import * as Sentry from '@sentry/react';
import classNames from 'classnames';
import { getProviderId, sendSdEvent } from 'src/helpers/ShiftDigitalHelper/ShiftDigitalHelper';

export interface IProps {
    rtsToken: string;
    viewMode: ViewMode;
    specData?: SpecData;
    theme: string;
    addlTrackToken: string;
    addlTrackVin: string;
    addlTrackYear: string;
    addlTrackMake: string;
    addlTrackModel: string;
    resetPassFlag: string;
    store: string;
    branch: string;
    decodeData: DecodeRec;
    optionsSelected?: NewVehicle;
    vehicles: VehicleRecs;
    specProfile: string;
    oemFirstName: string;
    oemLastName: string;
    oemEmail: string;
    oemPhone: string;
    oemError: string;
    custInfo?: Customer;
    errMsg?: string;
    loadNameId: string;
    loadVin: string;
    loadRO: string;
    loadAppt: string;
    apptList?: ViewApptList;
    toyLexStart: boolean;
    serviceDocsFlag: string;
    menusReturnCode: string;
    previousToken: string;
    logId?: string;
    countryCode: string;
    languageCode: string;
    locale: string;
    langOption: string;
    apptCustId?: string;
    goToLoginFlag: string;
    checkRepairStatusFlag: string;
    viewServiceHistFlag: string;
    repairOrders: RepairOrder[];
    sysId: string;
    identityVerified: boolean;
    verifyingIdentity: boolean;
    osdVerifyIdentityEnabled?: boolean;
    previewFlag: string;
    isMobile: boolean;
    serviceDocsSpecs: ServiceDocsData | undefined;
    viewRepairStatusFlag: boolean;
    vwDeepLinkMileage: string;
    vinCustReturned: boolean;
    inquiryReturned: boolean;
    inquiryError: boolean;
    waitOnMC: boolean;
    waitOnRecall: boolean;
    recalls: Recall[];
    MCReturned: boolean;
    MCError: boolean;
    maintContracts: MaintenanceContract[];
    recom: Recom[];
    selectedVehicle: string;
    sessionId: string;
    lexusMCLaunched: string;
    toyotaMCLaunched: string;
    lexusTDMCLaunched: string;
    toyotaTDMCLaunched: string;
    clearMainPanes: () => void;
    pushToMainPanes: (inputView: IView) => void;
    pushToLeftPane: (inputView: IView) => void;
    setViewMode: (viewMode: ViewMode) => void;
    getAddlTrackCustomerInfo: (token: string) => void;
    clearDecodeData: () => void;
    decodeVin: (id: string, store: string, branch: string) => void;
    onAddNewVehicle: (state: NewVehicle) => void;
    updateAppVehicle: (inp: UpdateApptVehInp) => void;
    addVehicle: (newVehicle: VehicleRec) => void;
    selectVehicle: (id: string) => void;
    clearAdditionalServices: () => void;
    UpdateApptOps: (inputOps: UpdateApptOpsInp[]) => void;
    getAdditionalServices: (profileNum: string, store: string, branch: string) => void;
    getRecalls: () => void;
    getApptOps: (profileNum: string, store: string, branch: string, vehData?: VehData) => void;
    getMaintContracts: () => void;
    getMenus: (value1, value2) => void;
    customerSearch: (cust: Customer, profile: string, store: string, branch: string, selectedNum?: string,
        landingPageFlag?: string) => void;
    vinCustomerSearch: (custVin: string) => void;
    onAppCustUpdate: (apptCust: UpdateApptCustInp) => void;
    onCustUpdate: (cust: Customer) => void;
    clearError: () => void;
    getVehicles: () => void;
    setVehNextAppt: (vehicleIndex: string, apptID: string) => void;
    getCustAppts: (custID: string, profile: string, store: string, branch: string) => void;
    updateApptDate: (apptDate: UpdateApptDateInp) => void;
    setToyLexStart: (inp: boolean) => void;
    getInvalidDates: (specProfile: string) => void;
    determineDept: (inp: DeteremineDeptInp) => void;
    getDeptSpecs: () => void;
    fetchROs: (custNum: string) => void;
    selectRO: (roNum: string) => void;
    getROHistory: () => void;
    getDocsROHistory: () => void;
    setERAError: (error: string) => void;
    addLogEntry: (action: string, screen: string, details: string) => void;
    toggleLocale: (locale: string) => void;
    checkAuthToken: () => void;
    checkAuthTokenOSD: (customerNameId: string) => void;
    clearCustInfo: () => void;
    clearVehicles: () => void;
    clearNewVehicle: () => void;
    clearApptState: () => void;
    clearROState: () => void;
    clearROHistory: () => void;
    clearMenusState: () => void;
    clearTokenData: () => void;
    // getIDMdoc: (docUUID: string, elementUUID: string) => void;
    // findIDMdocs: (store: string, branch: string, docType: string, key1: string,
    //     key1value: string, key2: string, key2value: string) => void;
    mainPaneViewOrder: IView[];
    logDocsHistory: (keyRO: string, action: string, docType: string, details: string, idmUrl: string) => void;
    setLoadingStateToIdle: () => void;
    setWaitOnRecall: (value: boolean) => void;
    setWaitOnMC: (value: boolean) => void;
    setApptHistId: (value: string) => void;
}

const LandingPage = (props: IProps & RouteComponentProps) => {
    const [fetchingSpecs, setFetchingSpecs] = useState(true);
    const [gettingAddlTrackCustomerInfo, setGettingAddlTrackCustomerInfo] = useState(false);
    const [gettingDeepLinkCustinfo, setGettingDeepLinkCustinfo] = useState(false);
    const [gettingResetPassCustInfo, setGettingResetPassCustInfo] = useState(false);
    const [decodingAddlTrackVin, setDecodingAddlTrackVin] = useState(false);
    const [decodingDeepLinkTrackVin, setDecodingDeepLinkTrackVin] = useState(false);
    const [addlTrackVehicleDone, setAddlTrackVehicleDone] = useState(false);
    const [addlTrackCustomerDone, setAddlTrackCustomerDone] = useState(false);
    const [deepLinkTrackVehicleDone, setDeepLinkTrackVehicleDone] = useState(false);
    const [deepLinkTrackCustomerDone, setDeepLinkTrackCustomerDone] = useState(false);
    const [searchingCust, setSearchingCust] = useState(false);
    const [gettingCustAppts, setGettingCustAppts] = useState(false);
    const [addingAddlTrackVehicle, setAddingAddlTrackVehicle] = useState(false);
    const [gettingFordMenus, setGettingFordMenus] = useState(false);
    const [loadROFlag, setloadROFlag] = useState(false);
    const [chkAuthToken, setChkAuthToken] = useState(false);
    const [chkAuthTokenOSD, setChkAuthTokenOSD] = useState(false);
    const [OSDLoadInfo, setOSDLoadInfo] = useState(false);
    const [fordPASSLoaded, setFordPASSLoaded] = useState(false);
    const [pageViewEvent, setPageViewEvent] = useState(false);
    const [vwDeepLinkCust, setVwDeepLinkCust] = useState(false);
    const [gettingVwMenus, setGettingVwMenus] = useState(false);
    const [recallDone, setRecallDone] = useState(false);
    const [mcDone, setMcDone] = useState(false);
    const [vwLoaded, setVwLoaded] = useState(false);
    const [vinErrorAddlCust, setVinErrorAddlCust] = useState(false);
    const [kiaCustReturned, setKiaCustReturned] = useState(false);

    const isSDAnalyticsEnabled =
        props.specData?.toyotaTrackingFlag === 'Y' ||
        props.specData?.lexusTrackingFlag === 'Y' ||
        props.specData?.mbzTrackingFlag === 'Y' ||
        props.specData?.mazdaCATrackingFlag === 'Y' ||
        props.specData?.vwTrackingFlag === 'Y' ||
        props.specData?.jaguarTrackingFlag === 'Y' ||
        props.specData?.landRoverTrackingFlag === 'Y';

    const history = useHistory();

    const sysNo = window.location.href.slice(11, 16);

    const currentViewPane = props.mainPaneViewOrder[props.mainPaneViewOrder.length - 1];
    const brandFlags = [
        props.specData?.fordSmarttFlag,
        props.specData?.kiaTrackingFlag,
        // Add more brand tracking flags here in the future
    ];
    const hasAnyBrandFlag = brandFlags.some(Boolean);

    useEffect(() => {
        if (props.logId) {
            // Don't add this log if we are loading an Appointment from token - the
            // user won't interact with the Landing Page
            if (!props.loadAppt && !props.addlTrackToken && !props.vwDeepLinkMileage) {
                props.addLogEntry('Screen Entry', 'Landing Page', '');
            }
        }
    }, [
        props.addLogEntry,
        props.logId,
        props.loadAppt,
        props.addlTrackToken,
        props.vwDeepLinkMileage,
    ]);

    useEffect(() => {
        // try this code first then try to pull from cookie.
        // if we have a utag visitor Id set it as the utag_main_v_id cookie.
        // if we don't try to get the visitor id from the cookie.
        if (props.specData?.tealiumAccount) {
            if (window.utag?.data?.tealium_visitor_id) {
                document.cookie = `tealium_visitor_id=${window.utag.data['tealium_visitor_id']};SameSite=None;secure`;
            } else if (window.utag?.v_id) {
                document.cookie = `tealium_visitor_id=${window.utag.v_id};SameSite=None;secure`;
            }
        }
    }, [props.specData?.tealiumAccount]);

    useEffect(() => {
        if (currentViewPane.viewId === ComponentMapIds.LandingPage) {
            setPageViewEvent(true);
        }
    }, [currentViewPane.viewId]);

    useEffect(() => {
        if (!props.loadAppt &&
            !props.addlTrackToken &&
            !props.loadNameId &&
            !props.vwDeepLinkMileage &&
            (props.specData?.tealiumAccount ||
            props.specData?.tagManagerId)) {
            if (pageViewEvent) {
                const ascPageViewInp: ascPageviewInput = {
                    pageType: 'home',
                    errorCode: '',
                    itemResults: '',
                };
                ascPageview(ascPageViewInp);
                setPageViewEvent(false);
            }
        }
    }, [
        props.loadAppt,
        props.addlTrackToken,
        props.loadNameId,
        props.specData?.tealiumAccount,
        props.specData?.tagManagerId,
        pageViewEvent,
        props.vwDeepLinkMileage,
    ]);


    useEffect(() => {
        if (props.specData?.mobileName !== '') {
            setFetchingSpecs(false);
            if (props.specData?.mobileName === undefined) {
                props.setERAError('specs');
            }
        } else {
            setFetchingSpecs(true);
        }
    }, [props.specData, setFetchingSpecs, props.setERAError]);


    // If the serviceDocsFlag is set, we have a token for Service Documents. Begin decoding
    // the token now; Service Documents will handle loading.
    useEffect(() => {
        if (props.serviceDocsFlag) {
            if (!chkAuthTokenOSD) {
                props.checkAuthTokenOSD(props.loadNameId);
                setChkAuthTokenOSD(true);
                setOSDLoadInfo(true);
            }
            // dealerName is required in spec set up which is why we are using it to tell we have the OSD specs back.
            if (chkAuthTokenOSD && OSDLoadInfo && props.serviceDocsSpecs?.dealerName && !props.verifyingIdentity) {
                const custInp: Customer = {
                    nameId: props.loadNameId,
                    firstName: '',
                    lastName: '',
                    emailAddress: '',
                    phoneNumber: '',
                    login: false,
                    prefContact: '',
                    textOptIn: '',
                    emailOptIn: '',
                    streetAddress: '',
                    stateAddress: '',
                    city: '',
                    zipCode: '',
                    addVehNameId: '',
                    gmRedeemAmt: '',
                    encryptFirst: '',
                    encryptLast: '',
                    encryptEmail: '',
                    encryptPhone: '',
                    ascCustId: '',
                };

                props.setViewMode(ViewMode.ServiceDocs);
                props.customerSearch(custInp, props.specProfile, props.store, props.branch, '0', '');
                props.fetchROs(props.loadNameId);

                if (!props.identityVerified && props.osdVerifyIdentityEnabled && props.previewFlag !== 'p') {
                    if (!props.verifyingIdentity) {
                        props.logDocsHistory(props.loadRO, 'IV', '', '', '');

                        // VerifyIdentity pops after verification so we need to push ServiceDocs first.
                        props.pushToMainPanes({
                            viewId: ComponentMapIds.ServiceDocs,
                            component: ComponentMapIds.ServiceDocs,
                        });
                        props.pushToMainPanes({
                            viewId: ComponentMapIds.VerifyIdentity,
                            component: ComponentMapIds.VerifyIdentity,
                        });
                    }
                } else {
                    props.clearMainPanes();
                    props.pushToMainPanes({
                        viewId: ComponentMapIds.ServiceDocs,
                        component: ComponentMapIds.ServiceDocs,
                    });
                }

                if (history) {
                    history.push('/' + window.location.search);
                }
                setOSDLoadInfo(false);
            }
        }
    }, [props.serviceDocsFlag,
        props.osdVerifyIdentityEnabled,
        props.store,
        props.branch,
        props.customerSearch,
        props.specProfile,
        props.fetchROs,
        props.setViewMode,
        props.loadNameId,
        props.history,
        props.pushToMainPanes,
        props.identityVerified,
        props.verifyingIdentity,
        props.checkAuthTokenOSD,
        props.logDocsHistory,
        props.loadRO,
        props.previewFlag,
        props.clearMainPanes,
        chkAuthTokenOSD,
        OSDLoadInfo,
        props.serviceDocsSpecs,
        history]);

    const schApptLit = props.specData?.schApptMsg;
    const yourAcctLit = props.specData?.yourAcctMsg;
    const checkRepairLit = props.specData?.checkRepairMsg;
    // DealerName should come from specs.  If it is blank then set it to strings.Dealership
    let dealerName = props.specData?.mobileName;
    const prefix = 'Mercedes-Benz';
    if (!dealerName || dealerName === '') {
        dealerName = strings.Dealership;
    }

    const isMercedesBenz = props.theme === 'mercedesBenz' && dealerName.toLowerCase().startsWith(prefix.toLowerCase());

    let mbName = '';
    let mbSubName = '';
    if (isMercedesBenz) {
        mbName = dealerName.slice(0, prefix.length);
        mbSubName = dealerName.slice(prefix.length).trim();
    }

    // useEffect for reset password token
    // if not fetchingSpecs then we check for reset password token
    // if token then we decode token
    // set gettingResetPassCustInfo to true
    // else no token passed load landing page/do nothing
    useEffect(() => {
        if (!fetchingSpecs) {
            if (props.resetPassFlag) {
                setGettingResetPassCustInfo(true);
            }
        }
    }, [props.resetPassFlag,
        fetchingSpecs]);

    // then useEffect where we check gettingReset and do customer search to get custinfo
    // once we have custinfo we should be able to go to the Reset Password screen
    useEffect(() => {
        if (gettingResetPassCustInfo && props.custInfo?.nameId && props.custInfo?.emailAddress) {
            setSearchingCust(false);
            props.setLoadingStateToIdle();
            if (!chkAuthToken) {
                props.checkAuthToken();
                setChkAuthToken(true);
            } else {
                // Identity verification is always required (mfaEnabled flag removed).
                if (!props.identityVerified) {
                    if (!props.verifyingIdentity) {
                        props.clearMainPanes();
                        props.setViewMode(ViewMode.CustAcct);
                        document.cookie = `token=${props.previousToken};SameSite=None;secure`;
                        props.pushToMainPanes({
                            viewId: ComponentMapIds.VerifyIdentity,
                            component: ComponentMapIds.VerifyIdentity,
                        });
                    }
                } else {
                    const apptCustInp: UpdateApptCustInp = {
                        nameId: props.custInfo!.nameId,
                        firstName: props.custInfo!.firstName,
                        lastName: props.custInfo!.lastName,
                        emailAddress: props.custInfo!.emailAddress,
                        phoneNumber: props.custInfo!.phoneNumber,
                        phoneType: props.custInfo!.phoneType,
                        prefContact: props.custInfo!.prefContact,
                    };
                    props.onAppCustUpdate(apptCustInp);
                    setGettingResetPassCustInfo(false);
                    props.clearMainPanes();
                    props.setViewMode(ViewMode.CustAcct);
                    document.cookie = `token=${props.previousToken};SameSite=None;secure`;
                    props.pushToMainPanes({
                        viewId: ComponentMapIds.ResetPassword,
                        component: ComponentMapIds.ResetPassword,
                    });
                }
            }
            // props.history.push('/cust');
        }
    }, [gettingResetPassCustInfo,
        props.custInfo,
        // props.history,
        props.previousToken,
        props.clearMainPanes,
        props.pushToMainPanes,
        props.onAppCustUpdate,
        props.setViewMode,
        props.identityVerified,
        chkAuthToken,
        props.checkAuthToken,
        props.verifyingIdentity,
        props.setLoadingStateToIdle,
    ]);

    useEffect(() => {
        // Continue with this useEffect once we have successfully loaded specs
        if (!fetchingSpecs) {
            // Perform VIN cust search for VW deep linking
            if (props.addlTrackVin && props.vwDeepLinkMileage && !props.resetPassFlag) {
                setVwDeepLinkCust(true);
                setGettingDeepLinkCustinfo(true);
                props.vinCustomerSearch(props.addlTrackVin);
                setDecodingDeepLinkTrackVin(true);
                props.clearDecodeData();
                props.decodeVin(props.addlTrackVin, props.store, props.branch);
                setDeepLinkTrackVehicleDone(true);
            }
            // If Addl OEM Track is active, the Landing Page will be suppressed.  We will determine
            // what do do based on the data from the token
            if (hasAnyBrandFlag && !props.resetPassFlag) {
                if (props.addlTrackVin) {
                    // An Addl Oem Track VIN was passed - start the process of decoding it
                    props.clearDecodeData();
                    props.decodeVin(props.addlTrackVin, props.store, props.branch);
                    setDecodingAddlTrackVin(true);
                }
                if (props.addlTrackToken) {
                    //  A token was passed, start the process of decoding it
                    props.getAddlTrackCustomerInfo(props.addlTrackToken);
                    setGettingAddlTrackCustomerInfo(true);
                    setAddlTrackVehicleDone(true);
                } else {
                    // check to see if an appt or vin was loaded into the token. if so,
                    // then we will perform a customer search.
                    if ((props.loadAppt && props.loadNameId) || props.loadVin) {
                        setSearchingCust(true);
                        const custInp: Customer = {
                            nameId: props.loadNameId,
                            firstName: '',
                            lastName: '',
                            emailAddress: '',
                            phoneNumber: '',
                            login: false,
                            prefContact: '',
                            textOptIn: '',
                            emailOptIn: '',
                            streetAddress: '',
                            stateAddress: '',
                            city: '',
                            zipCode: '',
                            addVehNameId: '',
                            gmRedeemAmt: '',
                            encryptFirst: '',
                            encryptLast: '',
                            encryptEmail: '',
                            encryptPhone: '',
                            ascCustId: '',
                        };
                        props.customerSearch(custInp, props.specProfile, props.store, props.branch, '0', '');
                    } else {
                        // No token was passed - load the ApptCust screen
                        // Also there was either no appointment loaded or the nameId was missing.
                        if (props.addlTrackMake || props.addlTrackVin) {
                            setAddlTrackVehicleDone(true);
                        }
                        props.setViewMode(ViewMode.Appt);
                        props.clearMainPanes();
                        props.pushToMainPanes({
                            viewId: ComponentMapIds.CustSearch,
                            component: ComponentMapIds.CustSearch,
                        });
                        if (history) {
                            history.push('/' + window.location.search);
                        }
                        // props.history.push('/appt');
                        // log Appointment Add Process Start action
                        props.addLogEntry('Appointment Add Process Start', '', '');
                    }
                }
            } else {
                // Addl OEM track is not active - if the DMS token found a NameID, we need to decode it now
                if (props.loadNameId) {
                    setSearchingCust(true);
                    const custInp: Customer = {
                        nameId: props.loadNameId,
                        firstName: '',
                        lastName: '',
                        emailAddress: '',
                        phoneNumber: '',
                        login: false,
                        prefContact: '',
                        textOptIn: '',
                        emailOptIn: '',
                        streetAddress: '',
                        stateAddress: '',
                        city: '',
                        zipCode: '',
                        addVehNameId: '',
                        gmRedeemAmt: '',
                        encryptFirst: '',
                        encryptLast: '',
                        encryptEmail: '',
                        encryptPhone: '',
                        ascCustId: '',
                    };
                    props.customerSearch(custInp, props.specProfile, props.store, props.branch, '0', 'Y');
                }
            }
        }
    }, [
        fetchingSpecs,
        props.addlTrackToken,
        props.addlTrackVin,
        props.store,
        props.branch,
        props.loadNameId,
        props.specProfile,
        props.resetPassFlag,
        props.getAddlTrackCustomerInfo,
        props.clearMainPanes,
        props.pushToMainPanes,
        props.setViewMode,
        props.clearDecodeData,
        props.decodeVin,
        props.customerSearch,
        props.addLogEntry,
        history,
        props.loadAppt,
        props.addlTrackMake,
        props.loadVin,
        hasAnyBrandFlag,
        props.vinCustomerSearch,
        props.vwDeepLinkMileage,
    ]);

    // Adding valid customer & vehicle info then performing necessary calls for VW Deep Linking.
    useEffect(() => {
        if (
            props.vinCustReturned &&
            props.custInfo?.nameId &&
            props.decodeData.make &&
            !gettingVwMenus &&
            !vwLoaded
        ) {
            setGettingDeepLinkCustinfo(true);
            setDeepLinkTrackCustomerDone(true);

            const apptCustInp: UpdateApptCustInp = {
                nameId: props.custInfo.nameId,
                firstName: props.custInfo.firstName,
                lastName: props.custInfo.lastName,
                emailAddress: props.custInfo.emailAddress,
                phoneNumber: props.custInfo.phoneNumber,
                phoneType: props.custInfo.phoneType,
                prefContact: props.custInfo.prefContact,
            };
            props.onAppCustUpdate(apptCustInp);
            props.getVehicles();
            const vehicles = props.custInfo.vehicleList;
            const vehicle = vehicles?.find(veh => veh?.vin?.slice(-8) === props.addlTrackVin?.slice(-8));
            const vehiclePrevMileage = vehicle?.prevMileage || 0;

            const deepLinkMileage = Number(props.vwDeepLinkMileage) || 0;
            const mileageValue = Math.max(vehiclePrevMileage, deepLinkMileage);

            const apptNewVehicle: UpdateApptVehInp = {
                vin: props.addlTrackVin,
                makeCode: props.decodeData.makeCode,
                make: props.decodeData.make,
                model: props.decodeData.model,
                vehYr: props.decodeData.year,
                vehColor: props.decodeData.color,
                mileage: mileageValue,
                imagePath: '',
                series: props.decodeData.style,
            };
            props.updateAppVehicle(apptNewVehicle);
            const vehicleIndex = vehicles?.findIndex(veh => veh?.vin?.slice(-8) === props.addlTrackVin?.slice(-8));

            if (vehicleIndex !== undefined && vehicleIndex !== -1 && vehicles?.[vehicleIndex] && !gettingVwMenus && !vwLoaded) {
                props.getAdditionalServices(props.specProfile, props.store, props.branch);
                props.selectVehicle(vehicleIndex.toString());
                props.setApptHistId(vehicleIndex.toString());
                props.getMenus('', '');
                props.getMaintContracts();
                props.setWaitOnMC(true);
                props.getRecalls();
                props.setWaitOnRecall(true);
                props.getApptOps(props.specProfile, props.store, props.branch);
                setGettingVwMenus(true);
                setVwLoaded(true);
            }
        } else {
            if (props.custInfo?.errMsg === undefined) {
                return;
            }
            setDecodingDeepLinkTrackVin(false);
            setGettingDeepLinkCustinfo(false);
        }
    }, [
        props.vinCustReturned, props.addlTrackVin, props.branch, props.custInfo, props.decodeData,
        props.getAdditionalServices, props.getApptOps, props.getMenus, props.getRecalls, props.getVehicles, props.onAppCustUpdate,
        props.selectVehicle, props.specProfile, props.store, props.updateAppVehicle, props.vwDeepLinkMileage, gettingVwMenus,
        props.getMaintContracts, props.setWaitOnMC, props.setWaitOnRecall, vwLoaded,
        props.selectedVehicle, props.setApptHistId,
    ]);

    useEffect(() => {
        if (props.vinCustReturned && (props.inquiryReturned || props.inquiryError)) {
            props.setWaitOnRecall(false);
            setRecallDone(true);
        }
    }, [props.inquiryReturned, props.inquiryError, props.setWaitOnRecall, props.vinCustReturned]);

    useEffect(() => {
        if (props.vinCustReturned && (props.MCReturned || props.MCError)) {
            props.setWaitOnMC(false);
            setMcDone(true);
        }
    }, [props.MCReturned, props.MCError, props.setWaitOnMC, props.vinCustReturned]);

    useEffect(() => {
        // If the Addl OEM Track VIN decode completes successfully, we need to add the vehicle info
        // to the active appointment
        if (decodingAddlTrackVin && props.decodeData.make && !vwDeepLinkCust) {
            setDecodingAddlTrackVin(false);
            if (props.decodeData.make !== 'ERROR') {
                const vehicleInfo = { ...props.optionsSelected! };
                vehicleInfo.vinValid = true;
                vehicleInfo.makeCode = props.decodeData.makeCode;
                vehicleInfo.make = props.decodeData.make;
                vehicleInfo.model = props.decodeData.model;
                vehicleInfo.year = props.decodeData.year;
                vehicleInfo.trim = props.decodeData.style;
                vehicleInfo.vin = props.addlTrackVin;
                props.onAddNewVehicle({ ...vehicleInfo });
                const apptNewVehicle: UpdateApptVehInp = {
                    vin: props.addlTrackVin,
                    makeCode: props.decodeData.makeCode,
                    make: props.decodeData.make,
                    model: props.decodeData.model,
                    vehYr: props.decodeData.year,
                    vehColor: props.decodeData.color,
                    mileage: 0,
                    imagePath: '',
                    series: props.decodeData.style,
                };
                props.updateAppVehicle(apptNewVehicle);
                // Should add the new Vehicle to the Vehicle state and then select that Vehicle
                const newStateVehicle: VehicleRec = {
                    id: '',
                    vin: props.addlTrackVin,
                    makeCode: props.decodeData.makeCode,
                    make: props.decodeData.make,
                    model: props.decodeData.model,
                    year: props.decodeData.year,
                    color: props.decodeData.color,
                    prevMileage: 0,
                    prevRoDate: '',
                    imagePath: '',
                    style: props.decodeData.style,
                    nextAppt: '',
                    lastAdv: '',
                    lastAdvName: '',
                    lastAdvImage: '',
                    lastTrans: '',
                    lastTransLit: '',
                    nameId: '',
                };
                props.addVehicle(newStateVehicle);
                setAddingAddlTrackVehicle(true);
            } else {
                setAddlTrackVehicleDone(true);
            }
        }
    }, [props.decodeData, props.addlTrackVin, props.updateAppVehicle, props.addVehicle,
        decodingAddlTrackVin, props.specProfile, props.store, props.branch, props.vehicles,
        props.onAddNewVehicle, props.optionsSelected, vwDeepLinkCust,
    ]);

    useEffect(() => {
        // If we just added a new vehicle from Ford, select the vehicle and continue processing
        if (addingAddlTrackVehicle) {
            setAddingAddlTrackVehicle(false);
            props.selectVehicle((props.vehicles.length).toString());
            props.clearAdditionalServices();
            props.UpdateApptOps([]);
            props.getAdditionalServices(props.specProfile, props.store, props.branch);
            props.getApptOps(props.specProfile, props.store, props.branch);
            props.getMenus('', '');
            setGettingFordMenus(true);
        }
    }, [props.selectVehicle, props.clearAdditionalServices, props.UpdateApptOps, props.getAdditionalServices,
        props.getApptOps, props.getMenus, props.specProfile, props.store, props.branch, props.vehicles,
        addingAddlTrackVehicle,
    ]);

    useEffect(() => {
        // If Ford menus return, turn off the gettingFordMenus flag and set FordVehicleDone
        if (gettingFordMenus && (props.menusReturnCode === '0000')) {
            setGettingFordMenus(false);
            setAddlTrackVehicleDone(true);
        }
    }, [gettingFordMenus, props.menusReturnCode]);

    useEffect(() => {
        // If the Addl OEM Track token was successfully decoded, we need to use the returned data to
        // initiate an ERA Customer search
        if ((gettingAddlTrackCustomerInfo && props.oemError !== '') || (!props.addlTrackToken && !props.vwDeepLinkMileage)) {
            setGettingAddlTrackCustomerInfo(false);
            if ((props.oemError !== '0000') || !props.addlTrackToken) {
                setAddlTrackCustomerDone(true);

                return;
            } else {
                setGettingAddlTrackCustomerInfo(true);
                setSearchingCust(true);
                const custInp: Customer = {
                    nameId: '',
                    firstName: props.oemFirstName,
                    lastName: props.oemLastName,
                    emailAddress: props.oemEmail,
                    phoneNumber: props.oemPhone,
                    login: false,
                    prefContact: '',
                    textOptIn: '',
                    emailOptIn: '',
                    streetAddress: '',
                    stateAddress: '',
                    city: '',
                    zipCode: '',
                    addVehNameId: '',
                    gmRedeemAmt: '',
                    encryptFirst: '',
                    encryptLast: '',
                    encryptEmail: '',
                    encryptPhone: '',
                    ascCustId: '',
                };
                props.customerSearch(custInp, props.specProfile, props.store, props.branch, '', '');
            }
        }
    }, [
        gettingAddlTrackCustomerInfo,
        props.oemError,
        props.specProfile,
        props.store,
        props.branch,
        props.oemEmail,
        props.oemFirstName,
        props.oemLastName,
        props.oemPhone,
        props.customerSearch,
        props.onCustUpdate,
        props.addlTrackToken,
        props.vwDeepLinkMileage,
    ]);

    useEffect(() => {
        // if we need to go straight to the login screen like we need to for the reset password confirmation
        // then we read the goToLoginFlag and go the the Your Account Login screen.
        if (props.goToLoginFlag) {
            props.setViewMode(ViewMode.CustAcct);
            props.clearTokenData();
            // props.clearMainPanes();
            props.pushToMainPanes({
                viewId: ComponentMapIds.Login,
                component: ComponentMapIds.Login,
            });
            if (history) {
                history.push('/' + window.location.search);
            }
        }
    }, [props.goToLoginFlag, props.setViewMode, props.clearTokenData, props.pushToMainPanes, history]);

    useEffect(() => {
        if (props.viewServiceHistFlag && props.loadNameId) {
            props.setViewMode(ViewMode.ViewServiceHist);
            setSearchingCust(true);
            const custInp: Customer = {
                nameId: props.loadNameId,
                firstName: '',
                lastName: '',
                emailAddress: '',
                phoneNumber: '',
                login: true,
                prefContact: '',
                textOptIn: '',
                emailOptIn: '',
                streetAddress: '',
                stateAddress: '',
                city: '',
                zipCode: '',
                addVehNameId: '',
                gmRedeemAmt: '',
                encryptFirst: '',
                encryptLast: '',
                encryptEmail: '',
                encryptPhone: '',
                ascCustId: '',
            };
            props.customerSearch(custInp, props.specProfile, props.store, props.branch, '0', '');
        }
    }, [props.viewServiceHistFlag, props.loadNameId, props.customerSearch, props.specProfile, props.store, props.branch,
        props.setViewMode]);

    useEffect(() => {
        // this will load the View Service History report accessible from the Service Docs menu item
        if (props.viewServiceHistFlag && (props.custInfo && props.custInfo.nameId !== '') &&
        props.loadVin && props.custInfo?.vehicleList) {
            const vehicles = props.custInfo.vehicleList;
            props.getVehicles();
            if (props.custInfo && props.custInfo.vehicleList) {
                const vehicles = props.custInfo.vehicleList;
                const selVeh = vehicles.findIndex(result => result.vin === props.loadVin).toString();
                props.selectVehicle(selVeh);
                const apptCustInp: UpdateApptCustInp = {
                    nameId: props.custInfo!.nameId,
                    firstName: props.custInfo!.firstName,
                    lastName: props.custInfo!.lastName,
                    emailAddress: props.custInfo!.emailAddress,
                    phoneNumber: props.custInfo!.phoneNumber,
                    phoneType: props.custInfo!.phoneType,
                    prefContact: props.custInfo!.prefContact,
                };
                props.onAppCustUpdate(apptCustInp);
                const apptNewVehicle: UpdateApptVehInp = {
                    vin: vehicles[selVeh].vin,
                    makeCode: vehicles[selVeh].makeCode,
                    make: vehicles[selVeh].make,
                    model: vehicles[selVeh].model,
                    vehYr: vehicles[selVeh].year,
                    vehColor: vehicles[selVeh].color,
                    mileage: vehicles[selVeh].mileage,
                    imagePath: vehicles[selVeh].imagePath,
                    series: vehicles[selVeh].style,
                };
                props.updateAppVehicle(apptNewVehicle);
            }
            props.clearTokenData();
            props.clearMainPanes();
            props.clearROHistory();
            props.getDocsROHistory();
            props.selectVehicle(vehicles.findIndex(result => result.vin === props.loadVin).toString());
            props.pushToMainPanes({
                viewId: ComponentMapIds.ViewServiceHistory,
                component: ComponentMapIds.ViewServiceHistory,
            });
            if (history) {
                history.push('/' + window.location.search);
            }
        }
    }, [props.viewServiceHistFlag,
        props.custInfo,
        props.loadVin,
        props.specProfile,
        props.branch,
        props.store,
        props.loadNameId,
        props.selectVehicle,
        props.clearMainPanes,
        props.clearTokenData,
        props.pushToMainPanes,
        props.clearROHistory,
        props.getDocsROHistory,
        props.getVehicles,
        props.onAppCustUpdate,
        props.updateAppVehicle,
        history]);

    useEffect(() => {
        // go to the repair order if the checkRepairStatusFlag is read from the token
        if (props.checkRepairStatusFlag && (props.custInfo && props.custInfo.nameId !== '') &&
        props.loadVin && props.custInfo?.vehicleList) {
            props.setViewMode(ViewMode.CustAcct);
            props.clearTokenData();
            props.getVehicles();
            if (props.custInfo && props.custInfo.vehicleList) {
                const vehicles = props.custInfo.vehicleList;
                // props.selectVehicle(vehicles.findIndex(result => {
                //     if (result.vin.includes('*')) {
                //         return result.vin.slice(9) === props.loadVin.slice(9);
                //     } else {
                //         return result.vin.slice(9) === props.loadVin.slice(9);
                //     }
                // }).toString());
                const selVeh = vehicles.findIndex(result => result.vin === props.loadVin).toString();
                props.selectVehicle(selVeh);
                const apptCustInp: UpdateApptCustInp = {
                    nameId: props.custInfo!.nameId,
                    firstName: props.custInfo!.firstName,
                    lastName: props.custInfo!.lastName,
                    emailAddress: props.custInfo!.emailAddress,
                    phoneNumber: props.custInfo!.phoneNumber,
                    phoneType: props.custInfo!.phoneType,
                    prefContact: props.custInfo!.prefContact,
                };
                props.onAppCustUpdate(apptCustInp);
                const apptNewVehicle: UpdateApptVehInp = {
                    vin: vehicles[selVeh].vin,
                    makeCode: vehicles[selVeh].makeCode,
                    make: vehicles[selVeh].make,
                    model: vehicles[selVeh].model,
                    vehYr: vehicles[selVeh].year,
                    vehColor: vehicles[selVeh].color,
                    mileage: vehicles[selVeh].mileage,
                    imagePath: vehicles[selVeh].imagePath,
                    series: vehicles[selVeh].style,
                };
                props.updateAppVehicle(apptNewVehicle);
            }
            if (props.loadNameId) {
                props.fetchROs(props.loadNameId);
                // Need to get customer appointment list as we skip over the userAccountMenu
                props.getCustAppts(props.custInfo.nameId, props.specProfile, props.store, props.branch);
            }
            setloadROFlag(true);

            // props.pushToMainPanes({
            //     viewId: ComponentMapIds.Login,
            //     component: ComponentMapIds.Login,
            // });
            // if (history) {
            //     history.push('/' + window.location.search);
            // }
        }
    }, [props.checkRepairStatusFlag,
        props.custInfo,
        props.loadVin,
        props.specProfile,
        props.branch,
        props.store,
        props.loadNameId,
        props.onAppCustUpdate,
        props.updateAppVehicle,
        props.setViewMode,
        props.clearTokenData,
        props.pushToMainPanes,
        props.getVehicles,
        props.fetchROs,
        props.getCustAppts,
        props.selectVehicle,
        history]);

    useEffect(() => {
        if (loadROFlag && props.repairOrders) {
            setloadROFlag(false);
            props.selectRO(props.loadRO);
            props.clearROHistory();
            props.getROHistory();
            props.pushToMainPanes({
                viewId: ComponentMapIds.VehLayout,
                component: ComponentMapIds.VehLayout,
            });
        }
    }, [loadROFlag,
        props.loadRO,
        props.repairOrders,
        props.selectRO,
        props.getROHistory,
        props.pushToMainPanes,
        props.clearROHistory,
    ]);

    useEffect(() => {
        if (props.viewRepairStatusFlag && !props.serviceDocsFlag && !props.viewServiceHistFlag &&
            (props.custInfo && props.custInfo.nameId !== '') &&
            props.loadVin && props.custInfo?.vehicleList) {
            props.setViewMode(ViewMode.CustAcct);
            props.clearTokenData();
            props.getVehicles();
            const vehicles = props.custInfo.vehicleList;
            const selVeh = vehicles.findIndex(result => result.vin === props.loadVin).toString();
            props.selectVehicle(selVeh);

            const apptCustInp: UpdateApptCustInp = {
                nameId: props.custInfo!.nameId,
                firstName: props.custInfo!.firstName,
                lastName: props.custInfo!.lastName,
                emailAddress: props.custInfo!.emailAddress,
                phoneNumber: props.custInfo!.phoneNumber,
                phoneType: props.custInfo!.phoneType,
                prefContact: props.custInfo!.prefContact,
            };
            props.onAppCustUpdate(apptCustInp);
            const apptNewVehicle: UpdateApptVehInp = {
                vin: vehicles[selVeh].vin,
                makeCode: vehicles[selVeh].makeCode,
                make: vehicles[selVeh].make,
                model: vehicles[selVeh].model,
                vehYr: vehicles[selVeh].year,
                vehColor: vehicles[selVeh].color,
                mileage: vehicles[selVeh].mileage,
                imagePath: vehicles[selVeh].imagePath,
                series: vehicles[selVeh].style,
            };
            props.updateAppVehicle(apptNewVehicle);
            props.fetchROs(props.loadNameId);
            // Need to get customer appointment list as we skip over the userAccountMenu
            props.getCustAppts(props.custInfo.nameId, props.specProfile, props.store, props.branch);

            props.getROHistory();
            props.pushToMainPanes({
                viewId: ComponentMapIds.VehLayout,
                component: ComponentMapIds.VehLayout,
            });

            if (history) {
                history.push('/' + window.location.search);
            }
        }
    }, [props.checkRepairStatusFlag,
        props.serviceDocsFlag,
        props.viewRepairStatusFlag,
        props.custInfo,
        props.loadVin,
        props.specProfile,
        props.branch,
        props.store,
        props.loadNameId,
        props.onAppCustUpdate,
        props.updateAppVehicle,
        props.setViewMode,
        props.clearTokenData,
        props.pushToMainPanes,
        props.getVehicles,
        props.fetchROs,
        props.getCustAppts,
        props.selectVehicle,
        history,
        props.loadRO,
        props.repairOrders,
        props.selectRO,
        props.getROHistory,
        props.clearROHistory,
        props.viewServiceHistFlag]);

    useEffect(() => {
        // If customer data was successfully decoded, we need to add the customer data to
        // the active appointment
        if (searchingCust && ((props.custInfo && props.custInfo.nameId !== '') || props.errMsg)) {
            setSearchingCust(false);
            props.setLoadingStateToIdle();

            if (!props.resetPassFlag && !props.serviceDocsFlag && !props.goToLoginFlag && !props.checkRepairStatusFlag &&
                !props.viewServiceHistFlag && !props.viewRepairStatusFlag) {
                if (hasAnyBrandFlag) {
                    setAddlTrackCustomerDone(true);
                }
                if (!props.errMsg) {
                    const apptCustInp: UpdateApptCustInp = {
                        nameId: props.custInfo!.nameId,
                        firstName: props.custInfo!.firstName,
                        lastName: props.custInfo!.lastName,
                        emailAddress: props.custInfo!.emailAddress,
                        phoneNumber: props.custInfo!.phoneNumber,
                        phoneType: props.custInfo!.phoneType,
                        prefContact: props.custInfo!.prefContact,
                    };
                    props.onAppCustUpdate(apptCustInp);
                    props.addLogEntry('Decoded Customer Data Successfully', '', '');
                    if (!hasAnyBrandFlag ||
                        props.loadAppt ||
                        (hasAnyBrandFlag && !props.addlTrackToken && props.loadVin)) {
                        let vehicleIndex = -1;
                        props.getVehicles();
                        // If a VIN was decoded, find the vehicle in the customer's vehicle list
                        // and mark it as the active vehicle
                        if (props.loadVin && props.custInfo?.vehicleList) {
                            vehicleIndex = props.custInfo.vehicleList.findIndex(result => result.vin === props.loadVin);
                            if (vehicleIndex !== -1) {
                                const apptNewVehicle: UpdateApptVehInp = {
                                    vin: props.custInfo.vehicleList[vehicleIndex].vin,
                                    makeCode: props.custInfo.vehicleList[vehicleIndex].makeCode,
                                    make: props.custInfo.vehicleList[vehicleIndex].make,
                                    model: props.custInfo.vehicleList[vehicleIndex].model,
                                    vehYr: props.custInfo.vehicleList[vehicleIndex].year,
                                    vehColor: props.custInfo.vehicleList[vehicleIndex].color,
                                    mileage: props.custInfo.vehicleList[vehicleIndex].prevMileage,
                                    imagePath: props.custInfo.vehicleList[vehicleIndex].imagePath,
                                    series: props.custInfo.vehicleList[vehicleIndex].style,
                                };
                                props.updateAppVehicle(apptNewVehicle);
                                props.selectVehicle((vehicleIndex).toString());
                                if (props.loadAppt) {
                                    props.setVehNextAppt((vehicleIndex).toString(), props.loadAppt);
                                }
                                props.clearAdditionalServices();
                                props.getAdditionalServices(props.specProfile, props.store, props.branch);
                                props.getMenus('', '');
                            }
                        }
                        // If an Appt# was decoded, start the process of retrieving the Appt data
                        if (props.loadAppt) {
                            props.getCustAppts(props.loadNameId, props.specProfile, props.store, props.branch);
                            setGettingCustAppts(true);

                            return;
                        }
                        // No Appt# was decoded - branch accordingly
                        props.setViewMode(ViewMode.Appt);
                        // log Appointment Add Process Start action
                        props.addLogEntry('Appointment Add Process Start', '', '');
                        props.clearMainPanes();
                        // If a vehicle exists, branch to the AddVehicle screen
                        if (vehicleIndex !== -1) {
                            props.getApptOps(props.specProfile, props.store, props.branch);
                            props.pushToMainPanes({
                                viewId: ComponentMapIds.AddVehicle,
                                component: ComponentMapIds.AddVehicle,
                            });
                            props.pushToLeftPane({
                                viewId: ComponentMapIds.PropertyOptions,
                                component: ComponentMapIds.PropertyOptions,
                            });
                            if (history) {
                                history.push('/' + window.location.search);
                            }

                            return;
                        }
                        // If the customer has no vehicles, branch to the AddVehicle screen
                        if (props.custInfo?.vehicleList?.length === 0) {
                            props.pushToMainPanes({
                                viewId: ComponentMapIds.AddVehicle,
                                component: ComponentMapIds.AddVehicle,
                            });
                        } else {
                            // If the customer has vehicles, branch to the VelSel screen
                            props.pushToMainPanes({
                                viewId: ComponentMapIds.VehSel,
                                component: ComponentMapIds.VehSel,
                            });
                        }
                        if (history) {
                            history.push('/' + window.location.search);
                        }
                        // props.history.push('/appt');

                        return;
                    }
                } else {
                    // The customer did not decode - put whatever info we do have into the
                    // active appointment
                    props.clearError();
                    const custInp: Customer = {
                        nameId: '',
                        firstName: props.oemFirstName,
                        lastName: props.oemLastName,
                        emailAddress: props.oemEmail,
                        phoneNumber: props.oemPhone,
                        login: false,
                        prefContact: '',
                        textOptIn: '',
                        emailOptIn: '',
                        streetAddress: '',
                        stateAddress: '',
                        city: '',
                        zipCode: '',
                        addVehNameId: '',
                        gmRedeemAmt: '',
                        encryptFirst: '',
                        encryptLast: '',
                        encryptEmail: '',
                        encryptPhone: '',
                        ascCustId: '',
                    };
                    props.onAppCustUpdate(custInp);
                    props.onCustUpdate(custInp);
                }
            }
        }
    }, [props, history, searchingCust, props.setLoadingStateToIdle, hasAnyBrandFlag]);

    useEffect(() => {
        // If an appointment list was found for the decoded customer, find the one that matches the
        // decoded Appt# and make it the active appointment before branching to the Summary screen
        // if (gettingCustAppts && props.apptList && props.loadAppt) {
        if (gettingCustAppts && props.apptList && props.apptCustId && props.loadAppt) {
            setGettingCustAppts(false);
            const apptList = props.apptList! ? props.apptList?.find(appt => appt.apptNum === props.loadAppt) : '';
            if (!apptList) {
                props.clearVehicles();
                props.clearApptState();
                props.clearCustInfo();
                props.clearMenusState();
                props.clearROHistory();
                props.clearROState();
                props.clearNewVehicle();
                props.clearTokenData();
            }
            if (apptList) {
                const date: UpdateApptDateInp = {
                    selDate: apptList.date,
                    selTime: apptList.time,
                    selTrans: apptList.trans,
                    selAdv: apptList.advisor,
                    selAdvName: apptList.advName,
                    selAdvImage: apptList.advImage,
                    selTransFlag: apptList.transFlag,
                    selApptNum: apptList.apptNum,
                };
                props.updateApptDate(date);
                const defaultDept = props.specData!.departmentFlag;
                const determineDept = {
                    defaultDept: defaultDept,
                };
                props.determineDept(determineDept);
                props.getDeptSpecs();
                if (!props.loadVin) {
                    const apptNewVehicle: UpdateApptVehInp = {
                        vin: apptList.vin,
                        makeCode: apptList.makeCode,
                        make: apptList.make,
                        model: apptList.model,
                        vehYr: apptList.year,
                        vehColor: '',
                        mileage: apptList.mileage,
                        imagePath: '',
                        series: '',
                    };
                    props.updateAppVehicle(apptNewVehicle);
                    // Should add the new Vehicle to the Vehicle state and then select that Vehicle
                    const newStateVehicle: VehicleRec = {
                        id: '',
                        vin: apptList.vin,
                        makeCode: apptList.makeCode,
                        make: apptList.make,
                        model: apptList.model,
                        year: apptList.year,
                        color: '',
                        prevMileage: apptList.mileage,
                        prevRoDate: '',
                        imagePath: '',
                        style: '',
                        nextAppt: '',
                        lastAdv: apptList.advisor,
                        lastAdvName: apptList.advName,
                        lastAdvImage: apptList.advImage,
                        lastTrans: apptList.transFlag,
                        lastTransLit: apptList.trans,
                        nameId: '',
                    };
                    props.addVehicle(newStateVehicle);
                    const vehIndex = props.vehicles?.findIndex(v => v?.vehApptList?.includes(props.loadAppt)) ?? -1;
                    if (vehIndex !== -1) {
                        props.selectVehicle(props.vehicles[vehIndex].id);
                    } else {
                        props.selectVehicle('0');
                    }
                }
                props.clearAdditionalServices();
                props.getAdditionalServices(props.specProfile, props.store, props.branch);
                props.getMenus('', '');
                props.UpdateApptOps([]);
                props.getApptOps(props.specProfile, props.store, props.branch);
                props.setViewMode(ViewMode.EditAppt);
                props.clearMainPanes();
                props.pushToMainPanes({
                    viewId: ComponentMapIds.Summary,
                    component: ComponentMapIds.Summary,
                });
                if (history) {
                    history.push('/' + window.location.search);
                }
            }
        }
    }, [
        gettingCustAppts,
        props.apptList,
        props.loadAppt,
        props.loadVin,
        props.store,
        props.branch,
        props.specProfile,
        props.pushToMainPanes,
        props.updateApptDate,
        props.clearMainPanes,
        props.setViewMode,
        props.getApptOps,
        props.specData,
        props.UpdateApptOps,
        props.clearAdditionalServices,
        props.getAdditionalServices,
        props.getMenus,
        props.getVehicles,
        props.selectVehicle,
        props.updateAppVehicle,
        props.addVehicle,
        props.determineDept,
        props.getDeptSpecs,
        props.apptCustId,
        history,
        props.clearVehicles,
        props.clearApptState,
        props.clearMenusState,
        props.clearCustInfo,
        props.clearROHistory,
        props.clearNewVehicle,
        props.clearROState,
        props.clearTokenData,
        props.decodeData.makeCode,
        props.vehicles,
    ]);

    useEffect(() => {
        // This useEffect activates when we are done decoding Addl OEM Track data
        if ((addlTrackVehicleDone && addlTrackCustomerDone) || (deepLinkTrackVehicleDone || deepLinkTrackCustomerDone)) {
            if (props.specData?.vwTrackingFlag && !props.vinCustReturned && props.custInfo?.errMsg === undefined && !props.errMsg) {
                return;
            }
            // If a vehicle decoded (and a VIN was passed), branch to the Update Mileage screen
            const lastPane = props.mainPaneViewOrder[props.mainPaneViewOrder.length - 1].viewId;
            if (props.addlTrackVin && props.decodeData.make !== 'ERROR' &&
                    (lastPane === ComponentMapIds.LandingPage) && (hasAnyBrandFlag)) {
                props.setViewMode(ViewMode.Appt);
                props.clearMainPanes();
                props.getApptOps(props.specProfile, props.store, props.branch);
                props.pushToMainPanes({
                    viewId: ComponentMapIds.AddVehicle,
                    component: ComponentMapIds.AddVehicle,
                });
                props.pushToLeftPane({
                    viewId: ComponentMapIds.PropertyOptions,
                    component: ComponentMapIds.PropertyOptions,
                });
                if (hasAnyBrandFlag) {
                    setFordPASSLoaded(true);
                }
            } else if ((!fordPASSLoaded) && (lastPane === ComponentMapIds.LandingPage)) {
                // VW Deep Linking to Additional Services or Services Tab based on returned recalls, maint contracts, and recoms.
                if (props.vinCustReturned){
                    if (!recallDone && !mcDone){
                        return;
                    } else if (recallDone && mcDone) {
                        if (props.recalls?.length > 0 || props.maintContracts?.length > 0 || props.recom?.length > 0) {
                            props.setViewMode(ViewMode.Appt);
                            props.clearMainPanes();
                            props.pushToMainPanes({
                                viewId: ComponentMapIds.AdditionalServices,
                                component: ComponentMapIds.AdditionalServices,
                            });
                        } else {
                            props.setViewMode(ViewMode.Appt);
                            props.clearMainPanes();
                            props.pushToMainPanes({
                                viewId: ComponentMapIds.ServiceTab,
                                component: ComponentMapIds.ServiceTab,
                            });
                        }
                        setGettingVwMenus(false);
                    }
                } else {
                    // If nothing decoded, branch to the Cust Search screen
                    props.setViewMode(ViewMode.Appt);
                    props.clearMainPanes();
                    if (vinErrorAddlCust && kiaCustReturned) {
                        props.getApptOps(props.specProfile, props.store, props.branch);
                        props.pushToMainPanes({
                            viewId: ComponentMapIds.AddVehicle,
                            component: ComponentMapIds.AddVehicle,
                        });
                        props.pushToLeftPane({
                            viewId: ComponentMapIds.PropertyOptions,
                            component: ComponentMapIds.PropertyOptions,
                        });
                    } else {
                        props.pushToMainPanes({
                            viewId: ComponentMapIds.CustSearch,
                            component: ComponentMapIds.CustSearch,
                        });
                    }
                }
            }
            if (history) {
                history.push('/' + window.location.search);
            }
            // log Appointment Add Process Start action
            props.addLogEntry('Appointment Add Process Start', '', '');
        }
    }, [addlTrackVehicleDone,
        addlTrackCustomerDone,
        props.clearMainPanes,
        props.pushToMainPanes,
        props.pushToLeftPane,
        props.setViewMode,
        props.decodeData.make,
        props.errMsg,
        gettingCustAppts,
        props.addlTrackVin,
        props.addLogEntry,
        history,
        props.mainPaneViewOrder,
        props.getApptOps,
        props.specProfile,
        props.store,
        props.branch,
        fordPASSLoaded,
        deepLinkTrackCustomerDone,
        deepLinkTrackVehicleDone,
        props.vinCustReturned,
        hasAnyBrandFlag,
        gettingVwMenus,
        props.custInfo,
        props.specData?.vwTrackingFlag,
        props.vwDeepLinkMileage,
        props.maintContracts,
        props.recom,
        props.recalls,
        props.menusReturnCode,
        props.waitOnRecall,
        recallDone,
        mcDone,
        props.oemError,
        vinErrorAddlCust,
        searchingCust,
        kiaCustReturned,
    ]);

    useEffect(() => {
        if ((props.decodeData.make !== 'ERROR' && props.addlTrackVin && props.specData?.kiaTrackingFlag)) {
            setVinErrorAddlCust(true);
        }
    }, [props.decodeData.make, props.addlTrackVin, props.specData?.kiaTrackingFlag, searchingCust, props.oemError]);


    useEffect(() => {
        if (props.specData?.kiaTrackingFlag) {
            if (props.oemError === '0000') {
                setKiaCustReturned(true);
            } else if (props.oemError === '4002' || props.oemError === '4003') {
                setKiaCustReturned(false);
            }
        }
    }, [props.specData?.kiaTrackingFlag, props.oemError]);

    const fireTrackingEvent = (e: React.SyntheticEvent, elementText: string, logRetailProcess: boolean = false) => {
        if (isSDAnalyticsEnabled) {
            sendSdEvent('scheduleServiceStart', {
                scheduleServiceSessionId: props.sessionId,
                scheduleServiceProvider: getProviderId(props.specData, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                    props.lexusMCLaunched, props.lexusTDMCLaunched),
            });
        }

        if (!props.toyLexStart) {
            props.setToyLexStart(true);
        }

        const isTrackingEnabled = props.specData?.tealiumAccount || props.specData?.tagManagerId;

        // Only log Retail Process for appointment CTA
        if (logRetailProcess) {
            const ascRetailProcessInp: ascRetailProcessInput = {
                pageType: 'service',
                flowName: 'appointment',
                elementTitle: 'Schedule Appointment',
                flowOutcome: 'start',
                flowStage: '1',
            };
            ascRetailProcess(ascRetailProcessInp);
        }

        if (isTrackingEnabled) {
            const ascCtaInteractionInp: ascCtaInteractionInput = {
                pageType: 'home',
                elementText,
                elementColor: '',
                elementOrder: '',
                elementType: 'scheduling_tool',
                elementSubType: 'nav_button',
                eventAction: 'click',
                eventActionResult: 'next_step',
                linkUrl: '',
            };
            ascCtaInteraction(ascCtaInteractionInp, e);
        }
    };

    // Sch Appt button.
    // Set viewMode to Appointment, clear the list of screens in the Main Pane. Go to the Appointment Customer screen.
    const schApptHandler = (e: React.MouseEvent<HTMLElement>) => {
        props.setViewMode(ViewMode.Appt);
        props.clearTokenData();

        props.pushToMainPanes({
            viewId: ComponentMapIds.CustSearch,
            component: ComponentMapIds.CustSearch,
        });

        if (history) {
            history.push('/' + window.location.search);
        }

        props.addLogEntry('Appointment Add Process Start', '', '');
        fireTrackingEvent(e, strings.SchAppt, true);
    };

    // Your Account button.
    // Set viewMode to Customer Account, clear the list of screens in the Main Pane. Go to the Login Screen
    const yourAcctHandler = (e: React.MouseEvent<HTMLElement>) => {
        props.clearTokenData();
        props.setViewMode(ViewMode.CustAcct);
        props.pushToMainPanes({
            viewId: ComponentMapIds.Login,
            component: ComponentMapIds.Login,
        });
        if (history) {
            history.push('/' + window.location.search);
        }
        fireTrackingEvent(e, strings.YourAcct);
    };

    // Check Repair Button.
    // Set viewMode to RepairOrder, clear the list of screens in the Main Pane.  Go to the Login Screen.
    const checkRepairHandler = (e: React.MouseEvent<HTMLElement>) => {
        props.clearTokenData();
        props.setViewMode(ViewMode.Repair);
        props.pushToMainPanes({
            viewId: ComponentMapIds.Login,
            component: ComponentMapIds.Login,
        });
        if (history) {
            history.push('/' + window.location.search);
        }
        fireTrackingEvent(e, strings.CheckRepair);
    };

    // if color theme is colorSensitive change to use the Alternate Css to remove the background image.
    let landingPageClassName = classNames(
        css.landingPage,
        {
            [css.LandingPageMB]: props.specData?.oemTheme === 'MB',
            [css.landingPagePorsche]: props.specData?.oemTheme === 'PO',
            [css.landingPageAlt]: props.theme === 'colorSensitive',
        },
    );

    let barId = 'bar';

    // If we dont have a background image then check if we have an OEM background
    // Otherwise set it to transparent so the default image will appear.
    let oemBGPath = '';
    if (!props.specData?.BGUrl || props.specData?.BGUrl === ' ') {
        if (props.specData?.oemTheme) {
            oemBGPath = getBackgroundPath(props.specData.oemTheme);
        }
        if (!props.specData?.oemTheme || !oemBGPath) {
            landingPageClassName = css.landingPageDefault;
        }
    }
    let CSSprogressColor = css.progressColor;
    if (props.theme === 'colorSensitive') {
        barId = 'barADA';
        CSSprogressColor = css.progressColorADA;
    }
    if (props.theme === 'buick') {
        barId = 'barBuick';
    }
    if (props.theme === 'genesis'){
        barId = 'barGenesis';
    }

    const barClassNames = classNames(
        {
            [css.barCV]: props.theme === 'chevorlet',
            [css.barIN]: props.theme === 'infiniti',
            [css.barMB]: props.theme === 'mercedesBenz',
            [css.barAC]: props.theme === 'acura',
        },
    );

    const startClassNames = classNames(
        css.start,
        {
            [css.startHeadingWeight]: props.theme === 'honda' || props.theme === 'ford' || props.theme === 'infiniti' ||
            props.theme === 'mercedesBenz',
            [css.startBuick]: props.theme === 'buick',
            [css.startBMW]: props.theme === 'bmw',
            [css.startMazda]: props.theme === 'mazda',
            [css.startAcura]: props.theme === 'acura',
            [css.startGenesis]: props.theme === 'genesis',
            [css.startLexus]: props.theme === 'lexus',
        },
    );

    const dealerClassNames = classNames(
        css.dealerName,
        {
            [css.lexusDealerName]: props.theme === 'lexus',
            [css.mbDealerName]: props.theme === 'mercedesBenz',
        },
    );

    let landingPage: ReactElement | null = null;

    if (fetchingSpecs ||
        decodingAddlTrackVin ||
        gettingAddlTrackCustomerInfo ||
        gettingFordMenus ||
        gettingCustAppts ||
        props.verifyingIdentity
    ) {
        landingPage = (
            <div className={css.landProgress}>
                <LoadingProgress cssClasses={{ spinner: CSSprogressColor }} size={100} />
            </div>
        );
    } else if (decodingDeepLinkTrackVin || gettingDeepLinkCustinfo || recallDone || mcDone) {
        landingPage = <div className={css.landProgress}></div>;
    } else {
        landingPage =
            <ScrollBar scrollVertical>
                <div className={css.scrollArea}>
                    <div className={css.xlate}>
                        {
                            sysNo === 'lhost' ?
                                <div> Current 35.500 </div> :
                                null
                        }
                    </div>
                    <Logo specData={props.specData} theme={props.theme} landingLogo={true}/>
                    {isMercedesBenz ? (
                        <div className={css.mbDealerName}>
                            <h1>{mbName}</h1>
                            <span>{mbSubName}</span>
                        </div>
                    ) : (
                        <h1 className={dealerClassNames}>{dealerName}</h1>
                    )}
                    <div className={startClassNames}>{strings.Start}</div>
                    <hr id={barId} className={barClassNames}></hr>
                    <div className={props.theme === 'buick' ? css.buttonBoxBuick : css.buttonBox}>
                        <Flexbox
                            container
                            spacing={0}
                            direction={'row'}
                            noMargin={false}
                            alignItems={'center'}
                            justify={'space-around'}>
                            <LandingButton
                                id={'schAppt'}
                                header={strings.SchAppt}
                                message={schApptLit}
                                iconName={IconSchAppt}
                                handler={schApptHandler}
                                title={strings.SchApptTitle}
                                lastFlag={false}
                                theme={props.theme}
                            ></LandingButton>
                            <LandingButton
                                id={'yourAcct'}
                                header={strings.YourAcct}
                                message={yourAcctLit}
                                iconName={IconYourAcct}
                                handler={yourAcctHandler}
                                title={strings.YourAcctTitle}
                                lastFlag={false}
                                theme={props.theme}
                            ></LandingButton>
                            <LandingButton
                                id={'checkRepair'}
                                header={strings.CheckRepair}
                                message={checkRepairLit}
                                iconName={IconCheckRepair}
                                handler={checkRepairHandler}
                                title={strings.CheckRepairTitle}
                                lastFlag={true}
                                theme={props.theme}
                            ></LandingButton>
                        </Flexbox>
                    </div>
                </div>
            </ScrollBar>;
    }

    return (
        <div id={'background'} className={landingPageClassName} >
            {landingPage}
        </div >
    );
};

export default LandingPage;
